document.addEventListener('DOMContentLoaded', function() {
  // Get the slide data elements
  const secondSlide = document.querySelector('.second-slide');
  const thirdSlide = document.querySelector('.third-slide');
  
  // Extract the data that was rendered by Liquid
  const slides = [
    {
      // Current slide data - already in the DOM
      title: document.querySelector('.hero-title').innerHTML,
      desc: document.querySelector('.heading__wysiwyg p').innerHTML,
      bgImage: document.querySelector('.full-bleed-hero').style.getPropertyValue('--bg') || 
               getComputedStyle(document.querySelector('.full-bleed-hero')).getPropertyValue('--bg')
    }
  ];
  
  // Add second slide data
  if (secondSlide) {
    const title2 = secondSlide.innerHTML.split('\n')[1].trim();
    const desc2 = secondSlide.innerHTML.split('\n')[2].trim();
    const bgImage2 = secondSlide.innerHTML.split('\n')[3].trim();
    
    slides.push({
      title: title2,
      desc: desc2,
      bgImage: `url('${bgImage2}')`
    });
  }
  
  // Add third slide data
  if (thirdSlide) {
    const bgImage3 = thirdSlide.innerHTML.split('\n')[1].trim();
    const title3 = thirdSlide.innerHTML.split('\n')[2].trim();
    const desc3 = thirdSlide.innerHTML.split('\n')[3].trim();
    
    slides.push({
      title: title3,
      desc: desc3,
      bgImage: `url('${bgImage3}')`
    });
  }
  
  // Elements to update
  const heroSection = document.getElementById('Banner-{{ section.id }}');
  const heroTitle = heroSection.querySelector('.hero-title');
  const heroDesc = heroSection.querySelector('.heading__wysiwyg p');
  const heroContainer = heroSection.querySelector('.full-bleed-hero');
  
  let currentSlideIndex = 0;
  let carouselInterval;
  let isPlaying = true;
  
  // Function to update slide with fade effect
  function updateSlide(index) {
    // Start fade out
    heroContainer.style.opacity = '0';
    
    // After fade out completes, update content and fade in
    setTimeout(() => {
      // Update content
      heroTitle.innerHTML = slides[index].title;
      heroDesc.innerHTML = slides[index].desc;
      
      // Update background
      heroContainer.style.setProperty('--bg', slides[index].bgImage);
      
      // Update indicator dots
      updateIndicators(index);
      
      // Start fade in
      heroContainer.style.opacity = '1';
      
    }, 500); // 500ms for fade out
  }
  
  // Function to cycle through slides
  function cycleSlides() {
    currentSlideIndex = (currentSlideIndex + 1) % slides.length;
    updateSlide(currentSlideIndex);
  }
  
  // Function to start carousel
  function startCarousel() {
    if (!isPlaying) {
      isPlaying = true;
      carouselInterval = setInterval(cycleSlides, 3000);
      updatePlayPauseButton();
    }
  }
  
  // Function to stop carousel
  function stopCarousel() {
    if (isPlaying) {
      isPlaying = false;
      clearInterval(carouselInterval);
      updatePlayPauseButton();
    }
  }
  
  // Function to toggle play/pause
  function togglePlayPause() {
    if (isPlaying) {
      stopCarousel();
    } else {
      startCarousel();
    }
  }
  
  // Function to go to a specific slide
  function goToSlide(index) {
    currentSlideIndex = index;
    updateSlide(currentSlideIndex);
    
    // Reset the timer if carousel is playing
    if (isPlaying) {
      clearInterval(carouselInterval);
      carouselInterval = setInterval(cycleSlides, 3000);
    }
  }
  
  // Function to update play/pause button appearance
  function updatePlayPauseButton() {
    const playPauseBtn = document.querySelector('.carousel-play-pause');
    if (playPauseBtn) {
      if (isPlaying) {
        playPauseBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="2" width="3" height="12" rx="1" fill="currentColor"/>
            <rect x="10" y="2" width="3" height="12" rx="1" fill="currentColor"/>
          </svg>
        `;
        playPauseBtn.setAttribute('aria-label', 'Pause carousel');
      } else {
        playPauseBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 2.5L13 8L4 13.5V2.5Z" fill="currentColor"/>
          </svg>
        `;
        playPauseBtn.setAttribute('aria-label', 'Play carousel');
      }
    }
  }
  
  // Function to update indicator dots
  function updateIndicators(activeIndex) {
    const indicators = document.querySelectorAll('.carousel-indicator');
    indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }
  
  // Create and add carousel controls
  function createCarouselControls() {
    const controlsContainer = document.createElement('div');
    controlsContainer.className = 'carousel-controls';
    
    // Create indicators
    const indicatorsContainer = document.createElement('div');
    indicatorsContainer.className = 'carousel-indicators';
    
    for (let i = 0; i < slides.length; i++) {
      const indicator = document.createElement('button');
      indicator.className = 'carousel-indicator';
      if (i === 0) indicator.classList.add('active');
      indicator.setAttribute('aria-label', `Go to slide ${i + 1}`);
      indicator.addEventListener('click', () => goToSlide(i));
      indicatorsContainer.appendChild(indicator);
    }
    
    // Create play/pause button
    const playPauseBtn = document.createElement('button');
    playPauseBtn.className = 'carousel-play-pause';
    playPauseBtn.addEventListener('click', togglePlayPause);
    
    // Set initial button state
    updatePlayPauseButton();
    
    // Add all controls to container
    controlsContainer.appendChild(indicatorsContainer);
    controlsContainer.appendChild(playPauseBtn);
    
    // Add controls to hero section
    heroSection.appendChild(controlsContainer);
  }
  
  // Create controls
  createCarouselControls();
  
  // Start the carousel
  carouselInterval = setInterval(cycleSlides, 3000);
});